import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
/**
 * Create a wrapper compose to support Popover functionality
 * @param ComposedComponent
 * @returns {{Component}}
 */

var withPopover = function withPopover(ComposedComponent) {
  return /*#__PURE__*/function (_Component) {
    _inherits(_class2, _Component);

    var _super = _createSuper(_class2);

    function _class2(props) {
      var _this;

      _classCallCheck(this, _class2);

      _this = _super.call(this, props);

      _this.closePopover = function () {
        _this.setState({
          show: false
        });
      };

      _this.openPopover = function (event) {
        if (event) {
          event.stopPropagation();
        }

        _this.setState({
          show: true
        });
      };

      _this.togglePopover = function (event) {
        if (event) {
          event.stopPropagation();
        }

        _this.setState(function (prevState) {
          return {
            show: !prevState.show
          };
        });
      };

      _this.state = {
        show: false
      };
      return _this;
    }

    _createClass(_class2, [{
      key: "render",
      value: function render() {
        var show = this.state.show;
        return /*#__PURE__*/React.createElement(ComposedComponent, _extends({}, this.props, {
          isPopoverOpen: show,
          closePopover: this.closePopover,
          openPopover: this.openPopover,
          togglePopover: this.togglePopover
        }));
      }
    }]);

    return _class2;
  }(Component);
};

export default withPopover;